import { render, staticRenderFns } from "./FormProcessorAdminUi.vue?vue&type=template&id=c5181e7a&scoped=true"
import script from "./FormProcessorAdminUi.vue?vue&type=script&lang=ts"
export * from "./FormProcessorAdminUi.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5181e7a",
  null
  
)

export default component.exports